let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7iEUL")).then(() => parcelRequire('6rW2v'));